var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.layout.content.global_contents),function(child){return _c(_vm.getContent(child).layout,{key:`global-component-${_vm.getContent(child).name}`,tag:"component",attrs:{"content":_vm.getContent(child)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }